import { Typography } from "@mui/material"

export const ArrayMapProductCateogory = ({user}) => 
{
    return(
        <Typography variant="body1" color="text.primary">{user?.name}</Typography>
    )
}


export const ArrayMapProductCompany = ({user}) => 
{
    return(
        <Typography variant="body1" color="text.primary">{user?.client_name}</Typography>
    )
}



// export default ArrayMap